/**
 * Created by imranexpt on 26/03/2016.
 */
(function () {
    /** @ngInject */
    function WidgetBaseController($scope, $http, $state, Booking, waCalendar, $timeout, $document, $sce, Utils) {
        $scope.restaurant = restaurant_name;
        $scope.langid = langid;
        $scope.separated = settings.separated;
        $scope.settings = settings;
        $scope.meals = meals;
        $scope.booking = Booking;
        $scope.daily_message = '';
        $scope.last_timelist = [];
        $scope.calendars = [];
        var doingAjax = false;
        $scope.langTitle = langTitle;
        $scope.showLang = false;
        var showDesc = false;
        $scope._preset = { mealid: 0, date: '', time: '' };
        $scope.hasMoreMeals = function () {
            return _.size(meals) > 1;
        };
        $scope.setMeals = function (meals) {
            $scope.meals = meals;
        };
        /** reload widget **/
        var reloadTimer = null;
        $scope.showLinkedMeal = function () {
            return !_.includes(['meals', 'amounts', 'calendar'], $state.current.name);
        }
        var md = markdownit({html : true, linkify: true,typographer: true, breaks : true});

        if (settings.idle_reload_time > 0 && settings.idle_reload_url.length > 10) {
            window.addEventListener('mousemove', resetReloadTimer, false);
            window.addEventListener('click', resetReloadTimer, false);
            window.addEventListener('tap', resetReloadTimer, false);
            //window.addEventListener('DOMMouseScroll',resetReloadTimer,false);
            window.addEventListener('scroll', resetReloadTimer, false);
            window.addEventListener('touchmove', resetReloadTimer, false);
            window.addEventListener('MSPointerMove', resetReloadTimer, false);
            reloadTimer = window.setTimeout(reloadWidget, settings.idle_reload_time * (60 * 1000));
        }
        $scope.authPage = function(){
            if(auth && auth !== false && auth.email) {
                $scope.toggleLogoutLink();
                return;
            }
            $scope.booking.setMeal(false);
            $scope.goTo('auth');
        };
        function resetReloadTimer() {
            if (reloadTimer != null) {
                window.clearInterval(reloadTimer);
                reloadTimer = window.setTimeout(reloadWidget, settings.idle_reload_time * (60 * 1000));
            }
        }
        function reloadWidget() {
            window.location = settings.idle_reload_url;
        }

        /** end reload widget **/

        var blockedDates = false;
        var full_dates_processed = false;
        var full_dates_mealid = 0;
        Booking.setDate(moment.tgz());
        $scope.date = Booking.getDate('YYYY-MM-DD');
        var start_date;
        if (_.has(settings, 'start_month')) {
            start_date = moment.tgz(settings.start_month);
            if (moment.tgz().isBefore(start_date, 'month')) {
                var m_diff = start_date.diff(moment.tgz(), 'months');
                if (m_diff > 0)
                    max_time = max_time - m_diff;
                //if(moment(start_date).add(max_time,"months"))
                Booking.setDate(start_date);
                $scope.date = Booking.getDate('YYYY-MM-DD');
            }
            //Booking.setDate(settings.start_month);
        }
        $scope.calendar = new waCalendar({ date: angular.copy($scope.date), max_month_diff: max_time });
        $scope.calendar_next = new waCalendar({ date: angular.copy(moment($scope.date).add(1, "month")), max_month_diff: max_time });
        var ignore_ajax = false;

        if (_hasDate === true) {
            $scope.calendar.setToday(_widget_request.date);
        }
        $scope.getDescriptionMarkdown = function (text) {
            var txt = _.isObject(text) && _.has(text, $scope.langid) ? text[$scope.langid] : '';
            txt = md.render(txt).replace(/<\/?p\>/g, '');
            return $sce.trustAsHtml(txt);
        }
        $scope.getDescription = function (text, contentLength, offset) {
            offset = _.isUndefined(offset) ? 0 : offset;
            return $sce.trustAsHtml(_.isObject(text) && _.has(text, $scope.langid) ? text[$scope.langid].substring(offset, contentLength)  + (text[$scope.langid].length > contentLength ? '...' : '') : '');
        };
        $scope.getGiftcardDescr = function(){
            return $sce.trustAsHtml($scope.booking.giftcard.description);
        };
        $scope.canClose = function () { return window.location !== window.parent.location };
        $scope.getMinMaxAmounts = function (meal) {
            var min_people = _.parseInt(meal.min_amount);
            var max_people = _.parseInt(meal.max_amount);
            var amounts = [];
            if (settings.max_people > 0) {
                for (var i = 1; i <= settings.max_people; i++) {
                    if (min_people > 0 && i < min_people) {

                    } else if (max_people > 0 && i > max_people) {

                    } else {
                        amounts.push(i);
                    }
                }
            }
            var min = _.min(amounts);
            var max = _.max(amounts);
            if (min === max) return min;
            return min + ' - ' + max;
        };

        var _changeLang = false;
        /** set calendars **/
        var _dd = moment(angular.copy($scope.date));
        for (var i = 1; i <= ((max_time) || 3); i++) {
            _dd.date(1);
            $scope.calendars.push(
                new waCalendar({ date: _dd.format("YYYY-MM-DD"), max_month_diff: max_time })
            );
            _dd.add(1, "month");
        }


        $scope.changingLanguage = function (update) {
            if (!_.isUndefined(update)) _changeLang = update;
            return _changeLang;
        };
        $scope.changeLanguage = function (url) {
            if (/Safari/.test(navigator.userAgent) && window.self !== window.top) {
                document.querySelector('#langform').submit();
            } else {
                window.location = url;
            }
        };
        $scope.getWidgetQueryUrl = function () {
            var state = $state.current.name;
            if (state == 'amounts' && $scope.booking.mealid > 0) {
                qs = removeURLParameter(qs, 'mealid');
                qs = removeURLParameter(qs, 'date');
                return qs + '&mealid=' + $scope.booking.mealid;
            } else if (state == 'calendar' && $scope.booking.mealid && $scope.booking.amount > 0) {
                qs = removeURLParameter(qs, 'date');
                qs = removeURLParameter(qs, 'mealid');
                qs = removeURLParameter(qs, 'amount');
                return qs + '&mealid=' + $scope.booking.mealid + '&amount=' + $scope.booking.amount;
            } else if (state == 'time' && $scope.booking.mealid && $scope.booking.amount && $scope.booking.date) {
                qs = removeURLParameter(qs, 'date');
                qs = removeURLParameter(qs, 'mealid');
                qs = removeURLParameter(qs, 'amount');
                qs = removeURLParameter(qs, 'date');
                return qs + '&mealid=' + $scope.booking.mealid + '&amount=' + $scope.booking.amount + '&date=' + $scope.booking.getDate("YYYY-MM-DD");
            }
            return qs;
        };
        function removeURLParameter(url, parameter) {
            const params = new URLSearchParams(url);
            params.delete(parameter);
            return params.toString();
        }
        $scope.isSeparated = function (checkMobile) {
            if (!_.isUndefined(checkMobile)) return settings.mobile == checkMobile && settings.separated == true;
            return settings.separated == true;
        };
        $scope.reloadLanguage = function (lang) {
            window.location = '/reservation/?hash=' + hash + '&lang=' + lang;
            return;
        };

        $scope.isAjaxRequest = function () {
            if (ignore_ajax == true) return false;
            //if(doingAjax === true) return true;
            return $http.pendingRequests.length > 0;
        };
        $scope.doingAjax = function () { return doingAjax; };
        $scope.setAjaxMode = function (mode) {
            doingAjax = mode;
        };

        function stepWidget() {
            //showDesc = _widget_request.hasOwnProperty('description') && _widget_request.description == 'Y';
            /*var ua = navigator.userAgent.toLowerCase();
            if (ua.indexOf('safari') !== -1) {
                if (ua.indexOf('chrome') > -1) {

                } else {
                    if (document.cookie.indexOf('PHPSESSID') < 0 && _allow_temp) {
                        window.parent.postMessage("cookieReset", '*');
                    }
                }
            }*/
            /*if(_allow_temp && !navigator.cookieEnabled){
                alert("We can't store cookies which is required to make a reservation");
            }else {

            }*/
            if (!_.isUndefined(_widget_request)) {
                if (_widget_request.hasOwnProperty('date')) {
                    Booking.setDate(_widget_request.date);
                }
                if (_widget_request.hasOwnProperty('amount'))
                    Booking.amount = _.parseInt(_widget_request.amount);
                if (_widget_request.hasOwnProperty('mealid')) {
                    if(_widget_request.mealid == 'giftcard' && giftcards && _.size(giftcards) > 0){
                        var gc = _.head(giftcards);
                        if(gc){
                            $scope.booking.setGiftcard(gc);
                            $scope.goTo('giftcard');
                        }
                    }else {
                        var meal = _.find(meals, function (m) {
                            return m.id == _widget_request.mealid;
                        });
                        if (meal && meal.started) {
                            //check if widget requires code
                            if (settings.mc_enabled === 'Y' && _.includes(settings.mc_meals, meal.id)) {
                                //validate the mc code
                                if (!_.isUndefined(meal_code) && meal_code.length > 0) {
                                    $http.post("/booking-widget/api/validateMealCode", {
                                        hash: hash,
                                        mealid: meal.id,
                                        mc_code: meal_code
                                    }).then(function (response) {
                                        if (response.data.success !== true) {
                                            alert(response.data.errors);
                                        } else {
                                            if (_.has(response.data, 'meal') && response.data.meal !== false) {
                                                meals[$scope.booking.mealid] = response.data.meal;
                                                $scope.setMeals(meals);
                                            }
                                            $scope.calendars = [];
                                            if (_.has(response.data, 'max_time')) {
                                                var _dd = moment(angular.copy($scope.date));
                                                for (var i = 1; i <= ((response.data.max_time) || 3); i++) {
                                                    _dd.date(1);
                                                    $scope.calendars.push(
                                                        new waCalendar({
                                                            date: _dd.format("YYYY-MM-DD"),
                                                            max_month_diff: response.data.max_time
                                                        })
                                                    );
                                                    _dd.add(1, "month");
                                                }
                                            }


                                            $scope.booking.setMeal(meal);
                                            //if(typeof(dataLayer) !== 'undefined'){ dataLayer.push({'event': 'Choose-meal'}); }
                                            if (typeof (dataLayer) !== 'undefined') {
                                                dataLayer.push({
                                                    'event': 'waiterAidMessage',
                                                    'message': {'step': 'Choose-meal'}
                                                });
                                            }
                                            if (meal.type === 8) {
                                                $scope.booking.setTime('00:00');
                                                $scope.goTo('products');
                                                //showDesc = _widget_request.hasOwnProperty('description') && _widget_request.description == 'Y';
                                            } else {
                                                $scope.goTo((meal.type == 9 ? 'meals' : 'amounts'));
                                                //showDesc = _widget_request.hasOwnProperty('description') && _widget_request.description == 'Y';
                                            }
                                        }
                                    });
                                }
                            } else {
                                $scope.booking.setMeal(meal);
                                if (meal.type == 10) {
                                    $scope.booking.setTime('00:00');
                                    $scope.goTo('products');
                                    //showDesc = _widget_request.hasOwnProperty('description') && _widget_request.description == 'Y';
                                } else {
                                    if (_widget_request.custom_request === 'yes' && (settings.custom_request) && settings.custom_request === true) {
                                        $scope.booking.custom_request = true;
                                        $scope.booking.amount = '';
                                        $scope.booking.date = '';
                                        $scope.goTo('guest-details');
                                        //showDesc = _widget_request.hasOwnProperty('description') && _widget_request.description == 'Y';
                                        return;
                                    }
                                    if (_.has(_widget_request, 'amount') && $scope.booking.amount === _widget_request.amount) {
                                        $scope.goTo('calendar');
                                        //showDesc = _widget_request.hasOwnProperty('description') && _widget_request.description == 'Y';
                                    } else {
                                        if (meal.type == 8) {
                                            $scope.booking.setTime('00:00');
                                            $scope.goTo('products');
                                        } else {
                                            $scope.goTo((meal.type == 9 ? 'calendar' : 'amounts'));
                                            //showDesc = _widget_request.hasOwnProperty('description') && _widget_request.description == 'Y';
                                        }
                                    }

                                    if (_hasDate == true && _.has(_widget_request, 'date') && moment(_widget_request.date).isValid()) {
                                        $scope.booking.setDate(_widget_request.date);
                                        //if (_.has(_widget_request, 'time') && _allow_temp) {
                                        if (_.has(_widget_request, 'time')) {
                                            $scope.goTo('time');
                                            //$scope.booking.setTime(_widget_request.time);
                                            //$state.go('products', {}, {location: false});
                                        } else {
                                            $scope.goTo('time');
                                        }
                                        //showDesc = _widget_request.hasOwnProperty('description') && _widget_request.description == 'Y';
                                    }

                                    if (settings.waitb) {

                                        $scope.booking.initFromDbObj(_booking);
                                        if (_widget_request.hasOwnProperty('waitb') && !Booking.short_code) {
                                            Booking.short_code = _widget_request.waitb;
                                        }
                                        if (_widget_request.hasOwnProperty('waitb') && settings.autoplacing_labels) {
                                            delete _widget_request.time;
                                            $scope.booking.setDate(_widget_request.date);
                                            $scope.booking.setMeal(_.find(meals, {id: $scope.booking.meal.id}));
                                            $scope.goTo('time');
                                            return;
                                        }


                                        Booking.setTime(_widget_request.time);

                                        if (Booking.status == 0) {
                                            $state.go('success', {}, {location: false});
                                            return;
                                        }

                                        if (!Booking.checkGuest()) {
                                            //$state.go('terms', {}, {location: false});
                                            //$state.go('guest-details', {}, {location: false});
                                            $state.go('products', {}, {location: false});
                                            return;
                                        } else {
                                            $state.go('products', {}, {location: false});
                                            //$state.go('guest-details', {}, {location: false});
                                            return;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                Booking.setDate(moment());
            }
            if (_booking !== false && _booking.id > 0) {
                if (!Booking.no_show_text && _booking.no_show_text)
                    Booking.no_show_text = _booking.no_show_text;
                $state.go('success', {}, { location: false });
                return;
            }
        }
        $scope.signalClose = function () {
            if (window.self === window.top && window.history.length >= 1) {
                window.history.go(-1);
                return;
            }
            if (typeof (window.parent) !== 'undefined') {
                window.parent.postMessage('closeWaiteraidFrame', "*");
            }

        }
        $scope.canGoBack = function () {
            //if(settings.is_bb) return true;
            if($scope.booking.giftcard) return false;
            if($scope.booking && $scope.booking.meal && $scope.booking.meal.type == 11) return false;
            if (hash === '41216a0170e7bcb819a74eafe8d54a3d' && ($state.is('meals') || $state.is('amounts'))) return false;
            if (window.self !== window.top) {
                if ($state.is('meals')) return false;
                return true;
            }
            if ($state.is('meals') && window.self === window.top)
                return true;
            //if($state.is('meals') && settings.g_id > 0){
            //    return true;
            //}
            if (navigator.userAgent.match(/Android/i)
                || navigator.userAgent.match(/webOS/i)
                || navigator.userAgent.match(/iPhone/i)
                || navigator.userAgent.match(/iPad/i)
                || navigator.userAgent.match(/iPod/i)
                || navigator.userAgent.match(/BlackBerry/i)
                || navigator.userAgent.match(/Windows Phone/i)) {

            } else {
                return true;
            }
            if ($state.is('success') || $state.is('meals')) return false;
            return true;
            //!$state.is('meals')
        };
        var scrolled = 0;
        var headerImage = null;
        var headerTop = null;
        //var headerI = 0;

        $scope.$on("$viewContentLoaded", function () {
            $timeout(function () {
                headerImage = document.querySelector('.widget-header');
                headerTop = headerImage ? headerImage.getBoundingClientRect().height : 0;
                headerTop = headerTop > 0 ? headerTop : 0;
                if (scrolled > 0) {
                    window.scrollTo(0, scrolled);
                } else {
                    if (document.querySelector('.widget-header')) {
                        var hh = document.querySelector('.widget-header').clientHeight - 10;
                        if (document.querySelector('body').classList.contains("header-bg") && screen.width >= 600 && screen.height <= 1200)
                            if ($state.current.name !== '' && $state.current.name !== 'meals') {
                                var st = setInterval(function () {
                                    window.scrollTo(0, scrolled);
                                    scrolled += 20;
                                    if (scrolled >= hh) {
                                        clearInterval(st);
                                    }
                                }, 10);

                            }
                    }
                }
                initScroller();
            }, 0);
        });
        var refUrl = document.referrer == '' || document.referrer.indexOf('waiteraid') >= 0;
        $scope.stepBack = function () {
            if($state.is('auth')){
                $scope.goTo('meals');
                return;
            }
            //if($scope.booking.giftcard !== false && $state.is())
            if ($scope.booking.custom_request === true && $state.is('guest-details')) {
                $scope.booking.custom_request = false;
                $scope.goTo('amounts');
                return;
            }
            var paths = ['meals', 'amounts', 'calendar', 'time', 'products', 'confirm', 'guest-details', 'terms'];
            var indexes = [0, 0, 1, 2, 3, 3, 3, 3];
            if (Booking.waitlist) {
                paths.splice(4, 0, 'waitlist-time');
                indexes.push(4);
            }
            var indx = _.indexOf(paths, $state.current.name);
            if ($scope.booking.meal.type == 9) {
                if (indx === 4)
                    $scope.goTo(paths[2]);
                else if (indx === 2)
                    $scope.goTo(paths[0]);
            }
            if (indx === 0) {
                if (window.self !== window.top) {
                    window.top.postMessage("closeWaiteraidFrame", '*');
                    return true;
                } else if (settings.g_id && settings.g_id > 0 && refUrl) {
                    window.location = '/reservation/?hash=' + hash + '&version=new&mr=' + settings.g_id;
                } else if (window.history.length >= 1) {
                    window.history.go(-1);
                    return;
                } else {
                    return false;
                }
            } else if (indx >= 4) {
                var meal = _.find(meals, function (m) { return m.id == $scope.booking.mealid; });
                if (meal.type == 10) {
                    indx = 0
                }
            }
            $scope.goTo(paths[indexes[indx]]);
        };
        var lastPath = '';
        $scope.getLastPath = function(){
          return lastPath;
        };
        $scope.canShowDesc = function () { return ($scope.booking.meal.type == 9 || $scope.booking.meal.type == 10) || (_widget_request.hasOwnProperty('description') && _widget_request.description.toLowerCase() == 'y'); }//showDesc === true; };
        $scope.goTo = function (path, params) {
            params = typeof(params) !== 'undefined' ? params : {};
            if(lastPath !== path)
                lastPath = $state.current.name;
            if(path === 'giftcard' || path === 'guest-details' || path === 'terms' || path === 'success' || path === 'giftcard-payment'){
            }else{
                $scope.booking.giftcard = false;
            }
            if (path === 'calendar' && ($state.current.name === 'amounts' || $state.current.name === 'meals')) {
                full_dates_processed = false;
            }
            //showDesc = false;
            $state.go(path, params, { location: false });
        };
        $scope.showAuthLink = function(){
          if(!$scope.booking.mealid) return true;
          if($state.is('meals')) return true;
          return false;
        };
        /*var socket= new WebSocket('ws://127.0.0.1:1337');
        socket.onopen= function() {

        };
        socket.onmessage= function(s) {
            var data = JSON.parse(s.data);
            console.log("%c" + data.logMSG,'color:red', data.data);
            $scope.$apply();
        };*/

        $scope.isGiftCard = function () {
            if($scope.booking.giftcard) return true;
            var meal = false;
            if ($scope.booking.id) {
                meal = $scope.meals[$scope.booking.mealid];
            } else {
                meal = $scope.booking.mealid > 0 ? _.find($scope.meals, { id: $scope.booking.mealid }) : false;
            }
            if (meal && meal.type == '8') {
                return true;
            }
            return false;
        };
        $scope.setCalendars = function (calendars) {
            var meal = $scope.booking.mealid > 0 ? _.find($scope.meals, { id: $scope.booking.mealid }) : false;
            var disabled_days = [];
            if (meal)
                disabled_days = meal.calendar;
            if (meal.days_disabled) {
                _.forEach(meal.days_disabled, function (d) {
                    disabled_days[d] = 0;
                });
            }
            if (!_.isUndefined(calendars)) $scope.calendars = calendars;
            _.forEach($scope.calendars, function (c) {
                c.setDisabledDays(disabled_days);
            });
        };
        $scope.getBlockedDates = function () { return blockedDates; };
        $scope.getFullDatesStatus = function () {
            if (settings.calendar_full_dates != true) return false;
            if (full_dates_processed === false) return false;
            return full_dates_processed;
        };
        var isScrolled = false;
        var scrolldone = false;
        function initScroller() {
            if (scrolldone) return;
            scrolldone = true;
            if (settings.mobile === false) {
                if (headerTop > 50) {
                    $document.on("scroll", function (e) {
                        var topPos = window.pageYOffset || (window.scrollTop || window.scrollY);
                        if (topPos >= (headerTop - 50)) {
                            if (!isScrolled) {
                                document.querySelector('body').classList.add("fixed-position");
                                document.querySelector('body').classList.add("no-gap");
                            }
                            isScrolled = true;
                        } else {
                            if (isScrolled && topPos <= (headerTop - 55)) {
                                document.querySelector('body').classList.remove('fixed-position');
                                document.querySelector('body').classList.remove("no-gap");
                                isScrolled = false;
                            }
                        }
                    });
                } else {
                    document.querySelector('body').classList.add("fixed-position");
                }
            } else {

            }
        }
        $scope.ignoreAjaxService = function (chk) {
            ignore_ajax = chk;
        };
        $timeout(stepWidget, 200);
        $scope.getAuthName = function(){
          return auth && auth !== false && auth.firstname ? auth.firstname + ' ' + auth.lastname : 'Login';
        };
        $scope.isLoggedIn = function(){
            return auth && auth !== false && auth.email;
        };
        var showLogout = false;
        $scope.toggleLogoutLink = function(){
            showLogout = !showLogout;
        };
        $scope.isLogoutVisible = function(){
            return auth && auth !== false && auth.email ? showLogout : false;
        };
        $scope.doLogOut = function(){
            $http.post('/booking-widget/api/logout', {}).then(function(response){
                auth = false;
            });
        };
        $scope.loginFeature = function(){
            const params = new URLSearchParams(window.location.search);
            if (params.get('auth') === 'Y') {
                return true;
            }
            return false;
        };
    }
    angular.module("Waiteraid").controller("baseController", WidgetBaseController);
})();
